module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_03_770_280_vi-a8a9f863360b91478136f46b0e1dedb6.jpg";